export const CN_VERSION_GET_VERSION_INFORMATION =
  'CN_VERSION_GET_VERSION_INFORMATION';
export const CN_VERSION_GET_VERSION_INFORMATION_ERROR =
  'CN_VERSION_GET_VERSION_INFORMATION_ERROR';
export const CN_VERSION_GET_VERSION_INFORMATION_LOADING =
  'CN_VERSION_GET_VERSION_INFORMATION_LOADING';
export const CN_VERSION_ENQUEUE_UPDATE_LOADING =
  'CN_VERSION_ENQUEUE_UPDATE_LOADING';
export const CN_VERSION_SET_ENQUEUED_SUCCESSFUL =
  'CN_VERSION_SET_ENQUEUED_SUCCESSFUL';
export const CN_VERSION_ENQUEUE_UPDATE_ERROR =
  'CN_VERSION_ENQUEUE_UPDATE_ERROR';
export const CN_VERSION_UPDATE_LOADING = 'CN_VERSION_UPDATE_LOADING';
export const CN_VERSION_SET_PREVIEW_ENQUEUED_SUCCESSFUL =
  'CN_VERSION_SET_PREVIEW_ENQUEUED_SUCCESSFUL';
export const CN_VERSION_PREVIEW_LOADING = 'CN_VERSION_PREVIEW_LOADING';
export const CN_VERSION_ENQUEUE_PREVIEW_LOADING =
  'CN_VERSION_ENQUEUE_PREVIEW_LOADING';



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/CNVersionInformation/types.js